import React, {Component} from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {withRouter} from 'react-router';
import moment from 'moment';
import {Link} from 'react-router-dom';

import Pagination from '../../components/pagination/Pagination.js';
import PaginationList from '../pagination/PaginationList.js';
import NewsNoResults from './NewsNoResults.js';

//img
import noNewsImg from '../../assets/icons/examples-bg.png';

class NewsAll extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageNum: 1,
        };
    };

    setCurrentPage = (event) => {
        const {totalPages} = this.props;
        const newVal = event.target.value;

        if ((newVal <= totalPages && newVal >= 1) || newVal === '') {
            this.setState({pageNum: newVal !== '' ? parseInt(newVal, 10) : newVal});
        }
    };

    componentDidUpdate(prevProps) {
        const {page} = this.props;

        if (prevProps.page !== page ) {
            this.setState({pageNum: page});
        }
    };

    verticalOrient = {
        WebkitBoxOrient: 'vertical'
    };

    render() {
        const { clang, id, pageData, pageDataCategory, totalPages, page, setPageByNum, resetPageOnBlur, setNextPage, setPreviousPage, match } = this.props;
        return (
            <div className="news__all">
                <h3 className="news__all__header">
                    {lang[clang].news[id]}
                </h3>
                {pageDataCategory &&
                <p className="news__all__header-desc">
                    {pageDataCategory.description}
                </p>}

                {pageData.length < 1 &&
                    <NewsNoResults />}
                {pageData.length > 0 &&
                    <div>
                      <Pagination
                          totalPages={totalPages || 1}
                          currentPage={page}
                          currentPageState={this.state.pageNum}
                          setCurrentPage={this.setCurrentPage}
                          resetPageOnBlur={resetPageOnBlur}
                          setPageByNum={setPageByNum}
                          setNextPage={setNextPage}
                          setPreviousPage={setPreviousPage}/>
                      <ul className="news__all__list">
                          {pageData.map((dataItem, index) =>
                              <li key={index} className="news__all__list-item">
                                  <Link to={`${match.url}/${dataItem.id}`} title={dataItem.title.rendered} className="news__all__list-item--link">
                                      <div className="news__all__tag">{lang[clang].main_page[dataItem.categories[0]]}</div>
                                      <div className="news__all__img" style={{backgroundImage: "url(" + (dataItem.better_featured_image !== null ? dataItem.better_featured_image.source_url : noNewsImg) + ")"}}></div>
                                      <span className="news__all__circle"></span>
                                      <span className="news__all__line"></span>
                                      <div className="news__all__info">
                                          <h3 dangerouslySetInnerHTML={{__html: dataItem.title.rendered}} className="news__all__title" style={this.verticalOrient}>
                                          </h3>
                                          <p className="news__all__date">{moment(dataItem.date).format('DD/MM/YYYY')}</p>
                                          <p className="news__all__desc" dangerouslySetInnerHTML={{__html: dataItem.acf.news_post_desc}} style={this.verticalOrient}></p>
                                          <span className="news__all__btn">
                                              {lang[clang].read_more}
                                              <span className="news__all__btn-icon"></span>
                                          </span>
                                      </div>
                                  </Link>
                              </li>)}
                      </ul>
                      <PaginationList
                          totalPages={totalPages || 1}
                          currentPage={page}
                          setPageByNum={setPageByNum}
                          setNextPage={setNextPage}
                          setPreviousPage={setPreviousPage}/>
                    </div>}
            </div>
        );
    };
};

NewsAll.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default withRouter(connect(mapStateToProps)(NewsAll));



// WEBPACK FOOTER //
// ./src/components/news/NewsAll.js